export default "/images/Output.svg?1a577f65d500925c0ae31b280d1dbdef";